var _path, _path2, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurface(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ae0b381d-263d-4d85-8cee-74003d9e304a",
    "data-name": "b2a23365-4853-4b8a-a57e-d8a594625f07",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.39,21.76,25.9,19A6.22,6.22,0,1,0,17,13.42v.25l-5.28-3.19a.77.77,0,0,0-.69.06.64.64,0,0,0-.19.62l4.93,20.07a.6.6,0,0,0,.44.36.48.48,0,0,0,.54-.14l3.67-3,3.79,4.16a.61.61,0,0,0,.62.2c.12,0,.22-.06.2-.17l4.4-3.27c.08-.14.27-.3.24-.42a.32.32,0,0,0-.1-.43L25.83,24.4l4.4-1.67c.22-.05.3-.19.36-.43A.51.51,0,0,0,30.39,21.76Z",
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.15,10.69a.9.9,0,0,1-.64-.22.75.75,0,0,1-.22-.59.77.77,0,0,1,.22-.58,1,1,0,0,1,1.26,0,.74.74,0,0,1,.23.58.76.76,0,0,1-.23.59A.88.88,0,0,1,23.15,10.69Zm-.7,6.67V11.71h1.38v5.65Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.25,
    cy: 13.4,
    r: 6.23,
    fill: "#fff",
    stroke: "#1a1a1a",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.15,10.69a.9.9,0,0,1-.64-.22.75.75,0,0,1-.22-.59.77.77,0,0,1,.22-.58,1,1,0,0,1,1.26,0,.74.74,0,0,1,.23.58.76.76,0,0,1-.23.59A.88.88,0,0,1,23.15,10.69Zm-.7,6.67V11.71h1.38v5.65Z",
    fill: "#1a1a1a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurface);
export default __webpack_public_path__ + "static/media/Surface.dd621dc48e087fefb0fc2a9dbfe211d1.svg";
export { ForwardRef as ReactComponent };